
import React from "react";

const MusicClassification: React.FC = () => {
  const categories = [
    {
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>,
      title: "Human Generated",
      description: "Traditional music created entirely by human artists"
    },
    {
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
            <path d="M12 2v1" />
            <path d="m4.93 4.93 .71 .7" />
            <path d="m18.36 5.63 .71 -.7" />
          </svg>,
      title: "AI Assisted",
      description: "Music created through human-AI collaboration"
    },
    {
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M9 18V5l12-2v13" />
            <circle cx="6" cy="18" r="3" />
            <circle cx="18" cy="16" r="3" />
          </svg>,
      title: "AI Generated",
      description: "Music composed entirely by artificial intelligence"
    },
  ];

  return (
    <div className="py-16 bg-gradient-to-br from-tagblue/5 to-tagblue-light/5 relative overflow-hidden">
      {/* 3D Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-10 right-10 w-28 h-28 bg-tagblue/10 rounded-full backdrop-blur-sm animate-float" />
        <div className="absolute bottom-10 left-10 w-20 h-20 bg-tagblue-light/10 rounded-xl backdrop-blur-sm rotate-45 animate-float" style={{
          animationDelay: '3s'
        }} />
      </div>
      <div className="container mx-auto px-6 md:px-8 lg:px-12 relative z-10">
        <div className="text-center mb-12 max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-gray-900 via-tagblue to-gray-900 mb-4 leading-relaxed py-2">
            Music Classification Categories
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">Revolutionary framework for understanding and categorizing music in the AI era</p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {categories.map((category, index) => (
            <div key={index} className="text-center">
              <div className="text-tagblue mb-4 flex justify-center">
                {category.icon}
              </div>
              <h3 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">
                {category.title}
              </h3>
              <p className="text-base md:text-lg text-gray-600 leading-relaxed">
                {category.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MusicClassification;
